import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ROUTE_ORDER_SUBSCRIPTIONS } from "@config/constants";
import { isEmpty, isEqual } from "lodash";
import React, { memo, useRef, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
var Promotions = function(param) {
    var i18n = param.i18n, isHidden = param.isHidden, closePromotions = param.closePromotions, _param_planDetails = param.planDetails, planDetails = _param_planDetails === void 0 ? {} : _param_planDetails, prismicPlan = param.prismicPlan;
    var wrapperRef = useRef();
    var promoPics = useMemo(function() {
        var _planDetails_promoPics;
        return (planDetails === null || planDetails === void 0 ? void 0 : (_planDetails_promoPics = planDetails.promoPics) === null || _planDetails_promoPics === void 0 ? void 0 : _planDetails_promoPics.length) > 0 ? planDetails.promoPics : null;
    }, [
        planDetails === null || planDetails === void 0 ? void 0 : planDetails.promoPics
    ]);
    useEffect(function() {
        window.addEventListener("mousedown", handleClickOutside);
        return function() {
            window.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var cookieBannerContainer = document.getElementsByClassName("cookie-banner-wrapper")[0];
        var current = wrapperRef.current;
        if (current && !current.contains(e.target) && !isHidden) {
            if (!cookieBannerContainer || !cookieBannerContainer.contains(e.target)) {
                closePromotions();
            }
        }
    };
    var renderPromotions = function() {
        var promoLeft;
        var promoRight;
        if (!isEmpty(prismicPlan)) {
            var _prismicPlan_promo_left, _prismicPlan_promo_right;
            if (!isEmpty((_prismicPlan_promo_left = prismicPlan.promo_left) === null || _prismicPlan_promo_left === void 0 ? void 0 : _prismicPlan_promo_left.url)) {
                var _prismicPlan_promo_left1;
                promoLeft = /*#__PURE__*/ _jsx(Link, {
                    to: ROUTE_ORDER_SUBSCRIPTIONS,
                    onClick: closePromotions,
                    className: "promotion",
                    children: /*#__PURE__*/ _jsx("img", {
                        className: "promotion-image",
                        src: prismicPlan.promo_left.url,
                        alt: i18n.account.promotions
                    })
                }, (_prismicPlan_promo_left1 = prismicPlan.promo_left) === null || _prismicPlan_promo_left1 === void 0 ? void 0 : _prismicPlan_promo_left1.url);
            }
            if (!isEmpty((_prismicPlan_promo_right = prismicPlan.promo_right) === null || _prismicPlan_promo_right === void 0 ? void 0 : _prismicPlan_promo_right.url)) {
                var _prismicPlan_promo_right1;
                promoRight = /*#__PURE__*/ _jsx(Link, {
                    to: ROUTE_ORDER_SUBSCRIPTIONS,
                    onClick: closePromotions,
                    className: "promotion",
                    children: /*#__PURE__*/ _jsx("img", {
                        className: "promotion-image",
                        src: prismicPlan.promo_right.url,
                        alt: i18n.account.promotions
                    })
                }, (_prismicPlan_promo_right1 = prismicPlan.promo_right) === null || _prismicPlan_promo_right1 === void 0 ? void 0 : _prismicPlan_promo_right1.url);
            }
        } else if (!isEmpty(promoPics)) {
            promoPics.forEach(function(item) {
                if (item.position === "left") {
                    promoLeft = /*#__PURE__*/ _jsx(Link, {
                        to: ROUTE_ORDER_SUBSCRIPTIONS,
                        onClick: closePromotions,
                        className: "promotion",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "promotion-image",
                            src: item.url,
                            alt: i18n.account.promotions
                        })
                    }, item.url);
                }
                if (item.position === "right") {
                    promoRight = /*#__PURE__*/ _jsx(Link, {
                        to: ROUTE_ORDER_SUBSCRIPTIONS,
                        onClick: closePromotions,
                        className: "promotion",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "promotion-image",
                            src: item.url,
                            alt: i18n.account.promotions
                        })
                    }, item.url);
                }
            });
        }
        if (!promoLeft && !promoRight) {
            return /*#__PURE__*/ _jsx("div", {
                style: {
                    margin: "100px auto 0"
                },
                children: /*#__PURE__*/ _jsx("h1", {
                    style: {
                        fontWeight: "400"
                    },
                    children: i18n.account.promotionsError
                })
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "modal-content",
            children: [
                promoLeft,
                promoRight
            ]
        });
    };
    if (planDetails.promoPics.lenght === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "modal-overlay promotions-overlay".concat(isHidden ? " promo-hidden" : ""),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "modal promotions-modal-wrapper",
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "modal-title",
                            children: i18n.account.promotions
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            onClick: closePromotions,
                            className: "icon icon-clear pointer"
                        })
                    ]
                }),
                renderPromotions()
            ]
        })
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(Promotions, areEqual);
